import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
  selector: 'versement-amount-form',
  templateUrl: './versement-amount-form.component.html',
  styleUrls: ['./versement-amount-form.component.scss'],
  standalone: false,
})
export class VersementAmountFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = { icon: 'info' };
  minAmount: number = 0;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit(): void {
    this.subscriptionFacade.initForm(this);

    this.initMinAmount();
  }

  get isProgramme(): boolean {
    return this.entity?.operation === 'VERSEMENT_PROGRAMME';
  }

  get isQuarterly(): boolean {
    return (
      this.entity?.products?.[0]?.parameters?.avProgammedPaymentType ===
      'QUARTERLY'
    );
  }

  get amountLabel(): string {
    if (!this.isProgramme) return 'Quel montant souhaitez-vous verser ?';

    return this.isQuarterly
      ? 'Quel montant souhaitez-vous verser chaque trimestre ?'
      : 'Quel montant souhaitez-vous verser chaque mois ?';
  }

  get amountPlaceholder(): string {
    if (!this.isProgramme) return 'Exemple : 10 000 €';

    return this.isQuarterly
      ? 'Exemple : 600 € / trimestre'
      : 'Exemple : 200 € / mois';
  }

  get minimumLabel(): string {
    return this.isProgramme
      ? 'Le montant minimum de versement programmé sur ce contrat est de'
      : 'Le montant minimum de versement sur ce contrat est de';
  }

  initMinAmount() {
    this.productDao
      .getProduct(this.productId as any)
      .pipe(untilDestroyed(this))
      .subscribe(product => {
        const minimum = this.isProgramme
          ? this.isQuarterly
            ? product?.lifeInsuranceProgrammedPaymentTrimestriel
            : product?.lifeInsuranceProgrammedPaymentMensuel
          : product?.lifeInsuranceMinOnLifePayment;

        if (_.isNil(minimum)) return;

        this.minAmount = minimum;

        this.versementAmountControl.setValidators([
          Validators.required,
          Validators.min(this.minAmount),
        ]);
        this.versementAmountControl.updateValueAndValidity({
          emitEvent: false,
        });
      });
  }

  onSubmit() {
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
